<ion-header style="background-color: #000000;">
  <ion-toolbar style="--background:#000000">
    <ion-buttons slot="start">
      <ion-button (click)="showMenu($event)" id="menuButton">
          <ion-icon name="ellipsis-horizontal" style="color: white;"></ion-icon>
        </ion-button>
      </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="tool">
    <span class="tag" ngClass="{{marginLeftClass}}">
      #{{tagline}}
    </span>
  </ion-toolbar>
</ion-header>




